import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
interface Props {
  divideByUnit: string;
  divideQuantity: number;
  price: number;
  cssClass: string;
}
const DivideByUnitPrice = ({
  divideByUnit,
  divideQuantity,
  price,
  cssClass
}: Props) => {
  const divideByPrice = price / divideQuantity;
  const formattedPrice = divideByPrice > 0.01 ? formatAsCurrency.formatIfUndefined(divideByPrice) : "$0.01";
  return <span className={`font-normal text-gray-600 ${cssClass}`} data-testid="divide-by-unit-price" data-sentry-component="DivideByUnitPrice" data-sentry-source-file="DivideByUnitPrice.tsx">
      {formattedPrice}/{divideByUnit}
    </span>;
};
export default DivideByUnitPrice;